import { render, staticRenderFns } from "./ProductStockMonthlyWrhous.vue?vue&type=template&id=8577fff4&scoped=true&"
import script from "./ProductStockMonthlyWrhous.vue?vue&type=script&lang=js&"
export * from "./ProductStockMonthlyWrhous.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockMonthlyWrhous.vue?vue&type=style&index=0&id=8577fff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8577fff4",
  null
  
)

export default component.exports